export default __webpack_public_path__ + "static/media/volunteer.70af24ad.jpg";